export var FaqCategory;
(function (FaqCategory) {
    FaqCategory["Faq"] = "faq";
    FaqCategory["Claim"] = "claim";
})(FaqCategory || (FaqCategory = {}));
